const map_div = document.getElementById("map");

if (map_div) {
  const center = map_div.querySelector('address');
  let position = { lat: +center.dataset.lat, lng: +center.dataset.lon };
  const zoom = +center.dataset.zoom;

  const points = map_div.querySelectorAll('mark');

  let map;
  let stylesArray = [{
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [{ "color": "#444444" }]
  }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f2f2f2" }] }, {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [{ "visibility": "off" }]
  }, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{ "saturation": -100 }, { "lightness": 45 }]
  }, {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [{ "visibility": "simplified" }]
  }, {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [{ "visibility": "off" }]
  }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, {
    "featureType": "water",
    "elementType": "all",
    "stylers": [{ "color": "#e3d3d2" }, { "visibility": "on" }]
  }];

  async function initMap() {
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerView } = await google.maps.importLibrary("marker");

    map = new Map(map_div, {
      zoom: zoom,
      center: position,
      styles: stylesArray
    });

    const svgMarker = {
      path: "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z",
      fillColor: "#df9b9c",
      fillOpacity: 1,
      strokeWeight: 0,
      scale: .08,
      anchor: new google.maps.Point(192, 512)
    };

    const infoWindow = new google.maps.InfoWindow();

    points.forEach(e => {
      position = { lat: +e.dataset.lat, lng: +e.dataset.lon };
      const marker = new google.maps.Marker({
        position: position,
        map: map,
        icon: svgMarker,
        title: '<div class="locations__window"><p>' + e.dataset.label + '</p><a href="tel:' + e.dataset.phone + '" class="locations__icon locations__icon-phone">' + e.dataset.phone + '</a><a href="' + e.dataset.link + '" class="locations__icon locations__icon-map" target="_blank">Open in map</a></div>'
      });

      if (e.dataset.label != '') {
        marker.addListener("click", () => {
          infoWindow.close();
          infoWindow.setContent(marker.getTitle());
          infoWindow.open(marker.getMap(), marker);
        });
      }
    });
  }

  initMap();
}
